<template>
  <Modal position="end" ref="modalRef">
    <template #header>Title</template>
    <template #body>
      <div class="title-form">
        <input type="text" v-model="form.fields.title" ref="inputRef" />
      </div>
    </template>
    <template #footer>
      <Button variant="ghost" @click="close">Cancel</Button>
      <Button @click="save" :disabled="form.validation.$invalid" :loading="form.submitting">Save</Button>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { required } from '@vuelidate/validators';
import { useElementVisibility } from '@vueuse/core';
import { ref, watch } from 'vue';

import { Button, Modal, useForm } from '@tallo/design-system';
import { usePropertyStore } from '@tallo/investor/property';

const { property, updateDisplayName } = usePropertyStore();
const modalRef = ref<InstanceType<typeof Modal>>();
const inputRef = ref<HTMLInputElement | null>(null);
const isVisibleInput = useElementVisibility(inputRef);
const form = useForm<{ title: string }>(
  {
    title: property?.displayName || '',
  },
  {
    title: { required },
  },
);

function save() {
  form.submit(async () => {
    await updateDisplayName(form.fields.title);
    close();
  });
}

function close() {
  modalRef.value?.close();
}

watch(isVisibleInput, () => {
  if (isVisibleInput.value) {
    inputRef.value?.focus();
  }
});

defineExpose({
  modalRef,
});
</script>

<style scoped lang="scss">
.title-form {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  min-height: 12rem;

  input {
    width: 100%;

    outline: none;
    border: none;

    color: var(--t-color-neutral-950);
    font-size: var(--t-spacing-lg);
    font-weight: 600;
    text-align: center;
  }
}
</style>
